import { useEffect, useState } from "react";

const useDiaboloData = () => {
  const [diaboloData, setDiaboloData] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch("https://app.diabolo.io/exchanges/exchange/widget_best_trades")
      .then((res) => res.json())
      .then((data) => {
        let preparedData = [];

        if (Object.keys(data["trades"]).length > 0) {
          preparedData = data["trades"];
        } else {
          preparedData = false;
        }

        setDiaboloData(preparedData);
      })
      .finally(() => setLoading(false));
  }, []);

  return { diaboloData, isLoading };
};

export default useDiaboloData;
